import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_2 = { class: "text-end mb-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0 break-word" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Số lượng:")
], -1)
const _hoisted_4 = { class: "text-end mb-0 break-word" }
const _hoisted_5 = { class: "break-word" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0 break-word" }, [
  /*#__PURE__*/_createElementVNode("strong", { class: "break-word" }, "Thành tiền:")
], -1)
const _hoisted_7 = { class: "text-end mb-0 break-word" }
const _hoisted_8 = { class: "break-word" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-center mb-0" }, "ĐVT", -1)
const _hoisted_10 = { class: "d-flex align-items-center justify-content-center mb-0" }
const _hoisted_11 = { class: "d-flex justify-content-center flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    style: {"width":"100%"},
    size: "small",
    "max-height": "800",
    "empty-text": "Chưa có vật tư",
    "cell-style": {padding: '0', height: '10px'},
    border: true,
    data: _ctx.vatTuItems
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "ID",
        width: "50"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.id), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_word_break_column, {
        "header-title": "Tên",
        property: "ten_vat_tu"
      }),
      _createVNode(_component_word_break_column, {
        "header-title": "Mã",
        property: "ma_vat_tu"
      }),
      _createVNode(_component_el_table_column, {
        label: "Thu hồi",
        width: "120"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
            "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "C/ty duyệt",
        width: "120"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
            "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
            disabled: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      (_ctx.showPriceAndTotal)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            width: "150"
          }, {
            header: _withCtx(() => [
              _hoisted_1
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_2, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.don_gia)), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { width: "150" }, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.pivot.so_luong)), 1)
          ])
        ]),
        _: 1
      }),
      (_ctx.showPriceAndTotal)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            width: "150"
          }, {
            header: _withCtx(() => [
              _hoisted_6
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_7, [
                _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.pivot.so_luong, false)), 1)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, { width: "100" }, {
        header: _withCtx(() => [
          _hoisted_9
        ]),
        default: _withCtx((scope) => [
          _createElementVNode("p", _hoisted_10, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : '-'), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: _ctx.showDeleteButton ? 100 : 50,
        fixed: "right"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_ButtonCustom, {
              "color-type": _ctx.ButtonTypeColors.INFO,
              "button-type": _ctx.ButtonsType.INFO,
              onClick: ($event: any) => (_ctx.push(`/quan-ly/vat-tu/chi-tiet/${scope.row.id}`))
            }, null, 8, ["color-type", "button-type", "onClick"]),
            (_ctx.showDeleteButton)
              ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                  key: 0,
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "button-type": _ctx.ButtonsType.TRASH,
                  onClick: ($event: any) => (_ctx.$emit('remove', { id_vat_tu: scope.row.id }))
                }, null, 8, ["color-type", "button-type", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["width"])
    ]),
    _: 1
  }, 8, ["data"])), [
    [_directive_loading, _ctx.isLoading]
  ])
}